<template>
  <div class="global-loading">
    <van-overlay :show="showLoading">
      <div class="wrapper">
        <van-loading :type="loadingType" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
//使用vant的懒加载
import { Loading, Overlay } from "vant";
export default {
  name: "global-loading",
  props: {
    loadingType: {
      type: String,
      default: "spinner"
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data() {
    return {
      value: ""
    };
  },
  watch: {},
  methods: {}
};
</script>
<style lang="less">
.global-loading {
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
